<template>
  <div>
    <div  v-if="currentTime" class="timer">
      <section>
      	Please Complete within
      </section>
      <div v-if="days">
        {{ days }} <span class="days-text">Days</span>
      </div>
      <div v-if="hours">
         {{ hours | formatTime }} <span class="hr-text">Hrs </span>
      </div>
      <div> {{ minutes | formatTime }} <span class="min-text">Mins</span> </div>
      <div>{{ seconds | formatTime }} <span class="sec-text">Secs</span></div>
    </div>
    <div  v-if="!currentTime" class="timeUp">
      Time's Up!
    </div>
    
  </div>
</template>

<script>
  export default {
      props: {
        deadline: {
          type: String,
          required: true
        },
        speed: {
          type: Number,
          default: 1000
        }
      },
      data() {
        return {
          currentTime: null
        };
      },
      mounted() {
        setTimeout(this.countdown, 1000);
      },
      computed: {
        seconds() {
          return Math.floor((this.currentTime / 1000) % 60);
        },
        minutes() {
          return Math.floor((this.currentTime / 1000 / 60) % 60);
        },
        hours() {
          return Math.floor((this.currentTime / (1000 * 60 * 60)) % 24);
        },
        days() {
          return Math.floor(this.currentTime / (1000 * 60 * 60 * 24));
        }
      },
      filters: {
        formatTime(value) {
          if (value < 10) {
            return "0" + value;
          }
          return value;
        }
      },
      methods: {
        countdown() {
          
          this.currentTime = Date.parse(this.deadline) - Date.parse(new Date());
          if (this.currentTime > 0) {
            setTimeout(this.countdown, this.speed);
          } else {
            this.currentTime = null;
          }
        }
      }
  }
</script>

<style lang="scss" scoped>
  .timer{
    background-color: rgb(41, 47, 65);
    color: #fff;
    width: 240px;
    text-align: center;
    padding: 3px 10px;
    font-size: 13px;
    border-radius: 3px;
    div{
      display: inline-block;
      padding: 0 3px;
      width: 60px;
    }
  }
  .hr-text{
    color: rgb(255, 74, 74);
    
  }
  .min-text{
    color: rgb(56, 255, 89);
  }
  .sec-text{
    color: rgb(73, 167, 255);
  }
  .days-text{
    color: rgb(96, 79, 255);
  }
  .timeUp{
     display: inline-block;
     padding: 3px 20px;
     color: #fff;
     background-color: rgb(255, 65, 65);
     border-radius: 5px;
  }
</style>